import classNames from "classnames";

import styles from "./TextArea.module.css";

type TextAreaProps = {
  className?: string;
  placeholder: string;
  value: string;
  onChangeText: (value: string) => void;
};

export default function TextArea({
  className,
  placeholder,
  value,
  onChangeText,
}: TextAreaProps) {
  return (
    <textarea
      onChange={(event) => {
        onChangeText(event.target.value);
      }}
      className={classNames(className, styles.input)}
      placeholder={placeholder}
      value={value}
    />
  );
}
